import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

export const ns = 'login-page';
export const useLoginPageTranslation = (): UseTranslationResponse<typeof ns> => useTranslation(ns);
export const ruRu = ({
  [ns]: {
    error: {
      login_or_password_is_wrong: 'Email или пароль неверны',
      user_is_blocked: 'Пользователь заблокирован',
    },
  },
}) as Record<string, unknown>;
export const en = ({
  [ns]: {
    error: {
      login_or_password_is_wrong: 'Email or password is incorrect',
      user_is_blocked: 'User is blocked',
    },
  },
}) as Record<string, unknown>;
export const esEs = ({
  [ns]: {
    error: {
      login_or_password_is_wrong: 'El correo electrónico o la contraseña son incorrectos',
      user_is_blocked: 'El usuario está bloqueado',
    },
  },
}) as Record<string, unknown>;
export const ptBr = ({
  [ns]: {
    error: {
      login_or_password_is_wrong: 'E-mail ou senha incorretos',
      user_is_blocked: 'Usuário bloqueado',
    },
  },
}) as Record<string, unknown>;
